import styled from 'styled-components'
import { Avatar } from '@components/Avatar'
import { blackOrange, darkOrange, white } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { Button } from '@components/Button'
import { ErrorBanner } from '@components/Notice'

/* ---------- invitation (left, on the blue hero) ---------- */

export const Inviter = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;

	p {
		margin: 0;
		font-size: ${fontSizes.title};
		line-height: ${leading.snug};
		color: ${white}db;
	}

	b {
		color: ${white};
		font-weight: 700;
	}
`

/** The inviter, haloed against the hero. */
export const InviterAvatar = styled(Avatar)`
	box-shadow: 0 0 0 3px ${white}24;
`


export const TripName = styled.h1`
	${text.hero}
	color: ${white};
	margin: 26px 0 0;
	text-wrap: balance;

	${media.tablet} {
		font-size: ${fontSizes.heroSm};
	}
`

export const Meta = styled.p`
	margin: 16px 0 0;
	${text.labelSm}
	color: ${white}eb;
`

export const Going = styled.p`
	margin: 6px 0 0;
	font-size: ${fontSizes.base};
	line-height: ${leading.body};
	color: ${white}c7;
	max-width: 300px;
	text-wrap: pretty;
`

/* ---------- action (right) ---------- */

export const PrimaryButton = styled(Button).attrs({ size: 'lg' as const })`
	margin-top: 34px;
	width: 100%;
`

/** The way back when the join did not go through: under the retry, never instead of it. */
export const BackButton = styled(Button).attrs({ variant: 'secondary' as const, size: 'lg' as const })`
	margin-top: 10px;
	width: 100%;
`

export const AppLink = styled.a`
	display: block;
	/* Sits on the panel's bottom edge, like the landing card's copy-link. */
	margin-top: auto;
	padding-top: 22px;
	text-align: center;
	font-size: ${fontSizes.small};
	color: ${darkOrange};
	text-decoration: none;

	b {
		${text.labelSm}
		color: ${blackOrange};
	}

	&:hover b {
		text-decoration: underline;
	}
`

export const Checking = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 18px;
	min-height: 200px;
`

export const StatusLabel = styled.p`
	margin: 0;
	${text.label}
	color: ${blackOrange};
	text-align: center;
	text-wrap: balance;
`

/** The failed attempt, on the Notice band, under the panel title. */
export const AttemptError = styled(ErrorBanner)`
	margin-top: 14px;
	text-wrap: pretty;
`

export const SignOutButton = styled(Button).attrs({ variant: 'ghost' as const, size: 'sm' as const })`
	padding: 0;
`

